import { useLingui } from '@lingui/react';
import { Button, Group, Stack, Text } from '@mantine/core';
import { IconPointFilled } from '@tabler/icons-react';
export type UnavailableButtonProps = {
  status: 'available' | 'unavailable';
  btnStatus: 'started' | 'active' | 'completed' | undefined;
};
export const UnavailableButton: React.FC<UnavailableButtonProps> = ({
  status,
  btnStatus
}) => {
  const {
    i18n
  } = useLingui();
  return <Button fz={11} fw={700} h={52} bg="var(--icon-primary)">
      <Stack gap={0} align="center">
        <Text fz="xs" fw={700} c="var(--text-dark)" tt="uppercase">
          {status}
        </Text>
        <Group gap={6} align="center" wrap="nowrap">
          <Text fz={13} fw={500} tt="capitalize" c="var(--text-dark)">
            {btnStatus}
          </Text>

          {btnStatus !== 'completed' && <Group gap={0} wrap="nowrap">
              <IconPointFilled color="var(--text-pink)" size={20} />
              <Text fz="xs" fw={700} c="var(--text-pink)">
                {i18n._('LIVE')}
              </Text>
            </Group>}
        </Group>
      </Stack>
    </Button>;
};